import Tooltip from '@components/Tooltips/Tooltip';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const Container = styled.div<{height?:number, active?:boolean}>`
    width:100%;
    max-height: 100%;
    height:${props => props.height?props.height+ "px":"0"};
    overflow: hidden;
    display:flex;
    flex-direction: column;
    position: absolute;
    bottom:0;
    left:0;
    background:#fff;
    z-index: 3;
    box-shadow: 0 0 10px rgba(0,0,0,0.25);
    transition: all 0.8s ease-in-out;
    pointer-events:${props => props.active?"unset":"none"};
`; 

export const ButtonControls = styled.div`
    width:100%;
    display:flex;
    gap:20px;
    justify-content: end;
    padding:20px;
`; 

export const RowContent = styled.div`
    height:auto;
    width:100%;
    overflow-y:auto;
`;

export const Row = styled.div<{space?:boolean}>`
    margin-top: ${props => props.space?"auto":"unset"};
    width:100%;
    padding:10px 20px 0 20px;
`; 

export const RowTitle = styled.span`
    font-size: 16px;
    font-weight: 500;
    display:flex;
    justify-content: space-between;
    align-items: end;
    min-height:20px;

    span:nth-of-type(1){
        color:#FA505E;
        font-size: 14px;
    }

    span:nth-of-type(2){
        font-size: 10px;
        width: 50px;
        text-align: right;
    }
`; 

export const Content = styled.div`
    width:100%;
`; 

export const Check = styled.div<{checked?:boolean, red?:boolean}>`
    width:100%;
    display: flex;
    align-items: center;
    margin-top: 6px;
    cursor: pointer;

    > div{
        width:22px;
        height:22px;
        border:2px solid #121212;
        content: ' ';
        border-radius: 5px;
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg{
            transition: all 0.1s ease-in-out;
            opacity: ${props => props.checked?"1":"0"};
            height: 70%;
            path{
                fill:#121212;
            }
        }
    }

    span{
        font-size: 16px;
    }
`; 

export const NoteArea = styled.div`
    width:100%;
    border-radius: 5px;
    border:1px solid #2A848E;
    min-height: 95px;
    display:flex;
    flex-direction: column;

    textarea{
        width:100%;
        padding:8px 12px 0 12px;
        resize: none;
        height: auto;
        min-height: 50px;
        outline:none;
        font-size: 14px;
        border:none;
        border-radius: 5px;

        ::-webkit-scrollbar{
            width:8px;
            height:100%;
            background:#dfdfdf4e;
            border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb{
            background:#dfdfdf;
            border-radius: 10px;
        }
        ::-webkit-scrollbar-track{
            
        } 
    }
`; 

export const Tags = styled.div<{pad?:boolean, disableText?:boolean}>`
    width:100%;
    display:inline-flex;
    flex-wrap: wrap;
    gap:6px 12px;
    margin-top: ${props => props.pad?"auto":"6px"};
    padding:${props => props.disableText?"8px 12px":props.pad?"0 12px 8px 12px":"unset"};

`; 

export const Tag = styled('div', {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'display',
})<{bgColor?:string, c?:boolean, delete?:boolean, display?:boolean}>`
    background: ${props => props.bgColor?"#" + props.bgColor:"#959595"};
    color: ${props => props.c?"black":"#fff"};
    font-size: 16px;
    padding: ${props => props.delete?"2px 6px 2px 16px":"2px 16px"};
    border-radius: 5px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    cursor: pointer;
    display: ${props => props.display?"none":"flex"};
    align-items: center;
    
    div{
        margin-left: 6px;
        height:18px; 
        aspect-ratio: 1 / 1;
        border:1px solid ${props => props.c?"black":"#fff"};
        border-radius: 5px;
        display:flex;
        align-items: center;
        justify-content: center;

        svg{
            height:50%;
            path{
                fill: ${props => props.c?"black":"#fff"};
            }
        }
    }
`;
